import React, { Component } from "react";
import styles from "./Layout.module.css";

class Layout extends Component {
  render() {
    return (
      <div>
        <header className={styles.header}>Welcome to The Board</header>
        {this.props.children}
        <footer className={styles.footer}>
          &copy; Copyright 2020 by Divyam Tayal | All rights reserved.
        </footer>
      </div>
    );
  }
}

export default Layout;
